<script>
    import { onMount } from "svelte";
    import { ProviderName, IsAuthConfigValid } from "../store.js";
    import wrappedFetch from "../../../wrappedFetch.js";
    import Card from "../../components/card.svelte";
    import Button from "../../components/button.svelte";
    export let simsPrimaryErrMsg = "";
    export let clientId = "";
    export let secret = "";
    export let installKey="";
    export let estab="";
    let hostedMISText="";
    let isHostedMIS=false;
    let isButtonLoading = false;
    
    //   let isAuthConfigValid = false;
    onMount(async () => {
        switch ($ProviderName){
            case "integris g2":
                isHostedMIS = true;
                hostedMISText=`<p>Before proceeding, please follow the guide available on the button below to enable the RM Integris Datashare.</p>
                                <a class="btn btn-primary" href="https://nimbus.adept.education/user_guide/integris_g2.html" target="_blank">View Guide</a>`;
                break;
            case "bromcom":
            isHostedMIS = true;
            hostedMISText=`<p>BromCom use an API created by Wavenet Education to send the data from the school's MIS.</p>
                            <p>Please contact BromCom initially to let them know you would like to export data to Wavenet Education. They will be able to start the process for you. Once this is done, please proceed on this wizard. </p>`;
            break;
            case "pupilasset":
            isHostedMIS = true;
            hostedMISText=`<p>For setting up the import of data from Pupil Asset, we will need authorisation to access your data and also your school’s ID. For both of these things, please log into Pupil Asset and browse to Admin ] Export ] External API Integration: <a href="https://secure.pupilasset.com/integration.php?tab=OUT" target="_blank">https://secure.pupilasset.com/integration.php?tab=OUT</a></p>
                            <p>For the access, please grant 'Atomwide' at least permission for 'School Info', 'Students', 'Staff' and 'Groups' data. </p>
                            <p>For the ID, please retrieve it and then provide it in a case on our Issue Tracker. Our engineers will then complete our end of the set up.</p>
                            <p>Once you've received confirmation that our engineers have carried this out, please proceed with this wizard.</p>`;
            break;
            case "sims":
            isHostedMIS = true;
            hostedMISText=`<p>Before you proceed, please note that as part of the setup you will need to install and configure our AutoUpdate software on your school’s server to export the data from SIMS to us. Please follow the guide available on the button below for instructions on setting this up. </p>
                           <p>As part of the set up you will be asked for a license key, the unique license key for <b>${estab}</b> is: <b>${installKey}</b>.</p>
                           <a class="btn btn-primary" href="https://nimbus.adept.education/user_guide/sims.html" target="_blank" >View Guide</a>`;
            break;
        }
        
    });

    const onAuthenticate = async () => {
        if ($ProviderName == "scholarpack") authenticateScholarPack();
        if ($ProviderName == "arbor") authenticateArbor();   
        //nextScreen();
    };
    const authenticateScholarPack = async () => {
        isButtonLoading = true;
        let resp = await wrappedFetch(`/api/import/GetScholarPackAuthUrl`, {
            method: "post",
        });
        let authUrl = await resp.text();
        isButtonLoading = false;
        window.location.href = authUrl;
    };

    const authenticateArbor = async () => {
        isButtonLoading = true;
        let resp = await wrappedFetch(`/api/import/GetArborAuthUrl`, {
            method: "post",
        });
        let authUrl = await resp.text();
        isButtonLoading = false;
        window.location.href = authUrl;
    };

   
</script>

<Card>
    <div slot="header">
        <h3 style="margin-bottom:0px;">Setup</h3>
    </div>
    <div slot="body">
        {#if $IsAuthConfigValid && $IsAuthConfigValid == 1 && $ProviderName != 'simsprimary' && !isHostedMIS}
        <div class="form-group" style="margin-bottom:0px;">          
                The required permissions to import data from your school’s MIS have been granted. Please click the 'Next' button below to proceed.          
        </div>
        {:else if isHostedMIS}
        {@html hostedMISText}
            {:else if $ProviderName == 'simsprimary'}
                <div class="form-group" style="margin-bottom:0px;">
                    <p>To import data from SIMS primary, please enter your school’s details below. These can typically be found within SIMS Product Admin ] Security ] SIMS Link. </p>
                    <div class="row">
                        <div class="col-md-6">
                            Client ID
                            <input
                                class="form-control"
                                type="text"
                                bind:value={clientId} />
                        </div>
                        <div class="col-md-6">
                            Secret Key
                            <input
                                class="form-control"
                                type="text"
                                bind:value={secret} />                       
                    </div> 
                </div>                 
                </div>
                {#if simsPrimaryErrMsg != ''}
                   <br>
                            <span class="text-danger">{simsPrimaryErrMsg}</span>
                        
                {/if}
            {:else}
            <div class="form-group"> Please click the button below to log in to <span style="text-transform:capitalize">{$ProviderName}</span> and authorise for your school’s data to be released to Wavenet Nimbus.</div>
            <Button buttonClass={"btn-primary"} buttonText={$ProviderName+" Login"}  on:click={onAuthenticate} bind:isLoading={isButtonLoading}/>
            <!-- <button
                class="btn btn-primary"
                on:click={onAuthenticate}>{$ProviderName}
                Login</button> -->
        {/if}        
    </div>
    
</Card>
<br>